/**
 * The sample's dispatch groups: one per team on the Interactive Map, keyed as
 * the map keys them, each with the people who are told when it is sent.
 *
 * DEMONSTRATION contacts. The numbers are Saudi-format and the addresses are
 * example.com, so nothing here can reach a real person; the demonstration
 * never sends a message in any case — it records what would have gone.
 */
import type { DispatchGroup } from "../domain/dispatch";

const person = (name: string, n: number, slug: string) => ({
  name,
  phone: `+96655${String(1000000 + n).slice(-7)}`,
  email: `${slug}@example.com`,
});

export function mockDispatchGroups(): DispatchGroup[] {
  return [
    {
      key: "RFF1",
      name: "RFF 1",
      kind: "Rescue and fire fighting",
      members: [person("Watch A commander", 101, "rff1.commander"), person("RFF 1 driver", 102, "rff1.driver")],
    },
    {
      key: "RFF2",
      name: "RFF 2",
      kind: "Rescue and fire fighting",
      members: [person("RFF 2 crew lead", 103, "rff2.lead")],
    },
    {
      key: "OPS1",
      name: "Airside Ops 1",
      kind: "Airside operations",
      members: [person("Duty airside officer", 104, "ops1.duty")],
    },
    {
      key: "OPS2",
      name: "Airside Ops 2",
      kind: "Airside operations",
      members: [person("Airside inspector", 105, "ops2.inspector")],
    },
    {
      key: "AGL1",
      name: "AGL crew",
      kind: "Airfield lighting",
      members: [person("AGL technician 1", 106, "agl.tech1"), person("AGL technician 2", 107, "agl.tech2")],
    },
    {
      key: "SWP1",
      name: "Sweeper 1",
      kind: "Sweeping",
      members: [person("Sweeper operator", 108, "sweeper.operator")],
    },
    {
      key: "MNT1",
      name: "Maintenance 1",
      kind: "Maintenance department",
      members: [person("Maintenance foreman", 109, "mnt.foreman"), person("Electrician", 110, "mnt.electrician")],
    },
    { key: "SEC1", name: "Security patrol", kind: "Security", members: [person("Patrol officer", 111, "sec.patrol")] },
    {
      key: "EQP1",
      name: "Equipment",
      kind: "Plant and equipment",
      members: [person("Plant operator", 112, "eqp.operator"), { name: "Banksman" }],
    },
    {
      key: "SFO1",
      name: "Safety officer",
      kind: "Safety office",
      members: [person("Airside safety officer", 113, "safety.officer")],
    },
    {
      key: "CD1",
      name: "Civil Defence",
      kind: "Civil defence",
      members: [person("Civil Defence liaison", 114, "cd.liaison")],
    },
  ];
}
